export default "__VITE_ASSET__3c3fbd1e__"